import React from 'react';
import PropTypes, { string } from 'prop-types';

const PopupCloseIcon = ({ width, height, onClick, className }) => (
  <span
    role="none"
    className={`icon-close cursor-pointer ${className}`}
    onClick={onClick}
    style={{ width, height, color: '#989898' }}
  />
);

PopupCloseIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  className: string,
};

PopupCloseIcon.defaultProps = {
  width: 22,
  onClick: () => {},
  className: '',
};

export default PopupCloseIcon;
